import { ShowHideTable } from "../../NewProductCategories/ProductDetails/components/ShowHideTable";
import "./index.css";
import { getAllComponentList } from "../../../apis/Product/ComponentApi";
import { useEffect, useState, useMemo } from "react";
import PieChartWithCenterLabel from "./PieChartWithCenterLabel";
import OverviewMagnify from "./OverviewMagnify";
import ZoomOut from "../../../assets/yfs-label-retrieve/Subtract magnify.svg";

const PercentageCategoryPie = ({ productId }) => {
  const [fullCategoryPercentage, setFullCategoryPercentage] = useState([]);
  const [isZoomed, setIsZoomed] = useState(false);
  const [show, setShow] = useState(false);

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  const slicedData = useMemo(() => {
    return fullCategoryPercentage.slice(0, 3);
  }, [fullCategoryPercentage]);

  useEffect(() => {
    getAllComponentList({
      productId: productId,
      subcategoryId: null,
      setFullCategoryPercentage: setFullCategoryPercentage,
    });
  }, [productId]);

  const total = useMemo(() => {
    return fullCategoryPercentage.reduce((acc, item) => {
      return (acc += item.value);
    }, 0);
  }, [fullCategoryPercentage]);

  return (
    <OverviewMagnify
      toggleZoom={toggleZoom}
      setIsZoomed={setIsZoomed}
      isZoomed={isZoomed}
    >
      <div
        className="product-pie-bg"
        style={{
          minWidth: isZoomed ? "350px" : "none",
          flexDirection: isZoomed || show ? "column" : "row",
          paddingBottom: isZoomed || show ? "25px" : 0,
        }}
      >
        {isZoomed && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              marginBottom: "5px",
            }}
          >
            <button
              onClick={toggleZoom}
              className="zoom-button modal-zoom-button"
            >
              <img src={ZoomOut} alt="Zoom Out Icon" />
            </button>
          </div>
        )}
        <h5
          className="product-pie-title"
          style={{
            padding: !isZoomed && !show ? "25px" : 0,
            marginBottom: !isZoomed && !show ? "15px" : 0,
            marginTop: "10px",
          }}
        >
          Percentage of impact categorised
        </h5>
        {!show && !isZoomed && (
          <div style={{ marginLeft: "40px" }}>
            <h5 className="product-pie-text">Total CO₂e (kg)</h5>
            <h5 className="product-pie-text" style={{ fontSize: "20px" }}>
              {total && total?.toFixed(2)}
            </h5>
          </div>
        )}
        {(show || isZoomed) && (
          <PieChartWithCenterLabel
            data={show || isZoomed ? fullCategoryPercentage : slicedData}
            centerText={"Total Coe2 (kg)"}
            unit={"CO₂e(kg)"}
            isZoomed={isZoomed}
          />
        )}
        {!isZoomed && <ShowHideTable showTable={show} setShowTable={setShow} />}
      </div>
    </OverviewMagnify>
  );
};

export default PercentageCategoryPie;
